import { LivenessAppLaunchRequestType, LivenessLaunchResponseType } from '@hb/liveness/src/api/liveness/types';
import requestDefault from '@/shared/utils/request';
import { LivenessSourceTypeEnum } from '@hb/liveness/src/enums/liveness';
import { appVersion } from '@/shared/utils/platform';
import { getDeviceRiskData } from '@/shared/tools/startLiveness/utils';

export interface CustomRequestParamsType {
  ocrAfter?: boolean;
  ocrAfterLoan?: boolean;
}

/**
 * @desc APP端内获取唤醒活体所需参数
 * @yapi https://yapi.hellobike.cn/project/4693/interface/api/128604
 */
export const getAppLivenessLaunchTransaction = async (
  options: LivenessAppLaunchRequestType & CustomRequestParamsType,
): Promise<LivenessLaunchResponseType> => requestDefault.postGate(
  'f.fate.bio.launch',
  {
    ...options,
    version: appVersion || '5.82.0',
    sourceType: LivenessSourceTypeEnum.App,
    riskControlData: await getDeviceRiskData(),
  },
  {
    showErrMsg: undefined,
    showLoading: undefined,
  },
);
